module.exports = __webpack_public_path__ + "img/demo.1bf28eb3.svg";